module.exports = __webpack_public_path__ + "static/media/bsu_logo_black.d25114ac.svg";